import { cn } from "@/lib/utils";

interface HeaderSectionProps {
  label?: string;
  title: string;
  subtitle?: string;
  className?: string;
}

export function HeaderSection({ label, title, subtitle, className }: HeaderSectionProps) {
  return (
    <div className={cn("flex flex-col items-center text-center", className)}>
      {label ? (
        <div className="text-gradient_indigo-purple mb-3 text-sm font-bold uppercase tracking-wider md:text-base">
          {label}
        </div>
      ) : null}
      <h2 className="font-urban text-3xl font-extrabold tracking-tight text-foreground sm:text-4xl md:text-5xl">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-3 max-w-2xl text-balance text-sm leading-relaxed text-muted-foreground sm:text-base md:text-lg">
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
